module.exports = __webpack_public_path__ + "static/full2-b9d263e201c1756a0f7e9ffd75d0f64d.png";